var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformItalic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 14,
  viewBox: "0 0 7 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.103 6.447c.126-.315.273-.714.273-.924 0-.462-.504-.924-.966-.924-1.113 0-3.087 1.029-4.221 2.415-.084.189.084.462.336.504.336-.315 1.512-1.197 1.869-1.197.105 0 .105.126.042.294L.252 11.844c-.168.42-.252.672-.252.903 0 .252.42.84.966.84 1.722 0 3.591-1.407 4.41-2.499a.41.41 0 0 0-.399-.504c-.525.504-1.68 1.323-1.974 1.323-.147 0-.168-.126-.084-.315zM3.654 1.743c0 .672.462 1.197 1.239 1.197.966 0 1.596-.777 1.596-1.701C6.489.441 6.027 0 5.313 0c-.966 0-1.659.819-1.659 1.743"
})));
export default SvgLongformItalic;